// Placement picker that sits under an ad preview.
//
// Only shows the placements that actually run at the previewed canvas
// shape ON THAT PLATFORM — so a Meta 9:16 creative never offers Feed, a
// 4:5 never offers Reels, and a Performance Max creative is never
// offered Instagram furniture it will never run in. The list comes from
// useAdChrome(), which derives it from the ad's platformFormat.

import { Select } from '@chakra-ui/react';
import type { ChromeKind, ChromeOption } from './types';

export function ChromeSelect({
  value,
  options,
  onChange,
  size = 'xs',
  width = 'auto'
}: {
  value:    ChromeKind;
  options:  ChromeOption[];
  onChange: (kind: ChromeKind) => void;
  size?:    'xs' | 'sm' | 'md';
  width?:   string;
}) {
  return (
    <Select
      size={size}
      w={width}
      value={value}
      onChange={e => onChange(e.target.value as ChromeKind)}
      aria-label="Placement preview"
      title="Preview the placement chrome the platform draws over or around the creative"
    >
      {options.map(o => (
        <option key={o.kind} value={o.kind}>{o.label}</option>
      ))}
    </Select>
  );
}
